import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      clientMutationId
      errors
      authToken
      loginState {
        badge
        firstName
        lastName
        middleName
        inactivityTimeout
        secureLocation
        officer {
          id
          deptAttribute {
            assignment
            carNumber
            radioNumber
            secondaryAddress
            notes
            skillsList
            lastContactedAt
            status
            badge
            stateIdNumber
            login
            onDuty
            nletsDevId
            nletsLogin
            nletsOri
            nletsPassword
            scales {
              id
              name
              scaleMake {
                id
                name
              }
              scaleModel {
                id
                name
              }
              serialNumber
            }
            ori {
              id
              requireDrugType
              abbreviation
              oriName
              municipalityNumber
              enableCarStop
              oriAddress {
                lat
                lng
                name
              }
              moduleOptions {
                id
                name
              }
            }
            team {
              id
              name
            }
          }
          personalAttribute {
            firstName
            middleName
            lastName
          }
        }
        ori {
          id
          requireDrugType
          oriName
          abbreviation
          enableCarStop
          municipalityNumber
          enableCarStop
          oriAddress {
            lat
            lng
            name
          }
          moduleOptions {
            id
            name
          }
          dispatchedOris {
            id
          }
          editableOris {
            id
          }
          mutualAidOris {
            id
          }
          secondarySiblings {
            id
          }
        }
        oriId
        userId
        roles {
          id
          name
          oriId
          position
        }
        expiredPasswordInfo {
          expiredMsg
          expiresInMsg
        }
      }
    }
  }
`;

// Example input
// {
//   "input": {
//     "oriId": "1",
//     "login": "user",
//     "password": "password",
//     "token": "",
//     "clientMutationId": ""
//   }
// }
